import {apiUrl} from '../constants';
import axios from 'axios';
var request = axios.create({
    baseURL: apiUrl,
    headers: {'Authorization':'Bearer ' +localStorage.getItem('token'),'Content-Type':'application/json'}
})

export default class ReporteExtractosAPI {

    static GetCaffeniosWithCalculations(){
        return request.get('ExtractosCalculo/GetCaffeniosWithCalculations')
    } 

    static GetCaffeniosListCalculations(filterData){
        console.log(`filterData`, filterData)
        return request.post('ExtractosCalculo/CaffeniosListCalculations', filterData)
    }

    // static CreateFormulaData(formulaData){
    //     return request.post('/FormulaExtracto/NewFormulaExtracto', formulaData);
    // }

    // static UpdateFormulaData(formulaData){
    //     return request.put('/FormulaExtracto/UpdateFormulaExtracto', formulaData);
    // }
}
